// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CatalogSelectController from "./catalog_select_controller"
application.register("catalog-select", CatalogSelectController)

import CatalogFaceZipController from "./catalog_face_zip_controller"
application.register("catalog-face-zip", CatalogFaceZipController)

import CatalogErrataController from "./catalog_errata_controller"
application.register("catalog-errata", CatalogErrataController)

import AbilityBindingsController from "./ability_bindings_controller"
application.register("ability-bindings", AbilityBindingsController)

import CardZoomController from "./card_zoom_controller"
application.register("card-zoom", CardZoomController)

import HeroCardTitleController from "./hero_card_title_controller"
application.register("hero-card-title", HeroCardTitleController)

import PreconBuilderController from "./precon_builder_controller"
application.register("precon-builder", PreconBuilderController)

import PreconPdfController from "./precon_pdf_controller"
application.register("precon-pdf", PreconPdfController)

import PreconDecklistController from "./precon_decklist_controller"
application.register("precon-decklist", PreconDecklistController)

import IllustrationUploadController from "./illustration_upload_controller"
application.register("illustration-upload", IllustrationUploadController)

import TypeaheadController from "./typeahead_controller"
application.register("typeahead", TypeaheadController)
